import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import EricInspeccionesGrid from './EricInspeccionesGrid.js'
import EricInspeccionDetalle from './EricInspeccionDetalle.js'

class EricContainer extends Component {
	render() {
		return (
			<div className="content-wrapper">
				<Switch>
					<Route exact path={this.props.match.url} component={EricInspeccionesGrid} />
					<Route path={`${this.props.match.url}/:id`} component={EricInspeccionDetalle} />
				</Switch>
			</div>
		)
	}
}

export default EricContainer
